const base64ToArrayBuffer = (base64String: string) => {
  const binaryString = atob(base64String);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
};

const stringToArrayBuffer = (str: string) => {
  const buffer = new ArrayBuffer(str.length);
  const view = new Uint8Array(buffer);
  for (let i = 0, strLen = str.length; i < strLen; i++) {
    view[i] = str.charCodeAt(i);
  }
  return buffer;
};

const arrayBufferToBase64 = (buffer: ArrayBuffer) => {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
};

/** Cryptex transport encryption for identifier `mop` values in transit to Sharkey. */
export const encryptCryptexTransport = async (
  mopValue: string,
  cryptexPublicKey: string,
): Promise<string> => {
  const algorithm = { name: 'RSA-OAEP', hash: 'SHA-1' };
  const key = await crypto.subtle.importKey(
    'spki',
    base64ToArrayBuffer(cryptexPublicKey),
    algorithm,
    true,
    ['encrypt'],
  );
  const result = await crypto.subtle.encrypt(algorithm, key, stringToArrayBuffer(mopValue));
  return arrayBufferToBase64(result);
};
